<template>
  <base-section
    id="committees"
    :space="0"
  >
    <v-container>
      <div>
        <v-tabs
          id="tab-committee"
        >
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-program`"
            @click="goToTop"
          >
            Program Chair
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-topic`"
            @click="goToTop"
          >
            Topic Chairs
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-members`"
            @click="goToTop"
          >
            Program Committee Members
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-companions`"
            @click="goToTop"
          >
            Program Committee Companions
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-steering`"
            @click="goToTop"
          >
            Steering Committee
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-industrial`"
            @click="goToTop"
          >
            Industrial Board
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-organizing`"
            @click="goToTop"
          >
            Organizing Committee
          </v-tab>
          <v-tab-item
            :value="`tab-program`"
          >
            <program-committee />
          </v-tab-item>
          <v-tab-item
            :value="`tab-topic`"
          >
            <topic-chairs />
          </v-tab-item>
          <v-tab-item
            :value="`tab-members`"
          >
            <members />
          </v-tab-item>
          <v-tab-item
            :value="`tab-companions`"
          >
            <companions />
          </v-tab-item>
          <v-tab-item
            :value="`tab-steering`"
          >
            <steering />
          </v-tab-item>
          <v-tab-item
            :value="`tab-industrial`"
          >
            <industrial />
          </v-tab-item>
          <v-tab-item
            :value="`tab-organizing`"
          >
            <organizing-committee />
          </v-tab-item>
        </v-tabs>
      </div>
    </v-container>
    <span v-intersect="handleIntersect" />
  </base-section>
</template>
<script>
  import OrganizingCommittee from './OrganizingCommittee.vue'
  import ProgramCommittee from './ProgramCommittee.vue'
  import TopicChairs from './TopicChairs.vue'
  import Members from './Members.vue'
  import Companions from './Companions.vue'
  import Industrial from './Industrial.vue'
  import Steering from './Steering.vue'
  export default {
    name: 'Committees',
    components: { OrganizingCommittee, TopicChairs, Members, Companions, ProgramCommittee, Industrial, Steering },

    data: () => ({
      tab: null,
      items: [
        'Organizing Committee',
        'Program Chair',
        'Topic Chairs',
        'Program Committee Members',
        'Program Committee Companions',
      ],
    }),
    mounted () {
      document.getElementById('tab-committee').firstChild.style = 'position: fixed; background-color: #fafafa !important; width = 100%; margin-top: -11px; z-index: 5; width: 100%;'
    },
    methods: {
      handleIntersect (entries, observer) {
        if (entries[0].isIntersecting) {
          this.tab = 'tab-organizing'
        } else {
          this.tab = 'tab-program'
        }
      },
      goToTop () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
    },
  }
</script>
<style lang="sass">
  #committees
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
      padding: 0 9px
      min-width: 10px
      font-size: 0.81rem !important
</style>